/* eslint-disable @typescript-eslint/no-unused-vars */
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RegionManager } from '@scenario/models/region-manager.model';
import { RootState } from '@store/create-store';

export interface RegionManagerState {
  regionManagers: RegionManager[];
  isFetching: boolean;
  isSaving: boolean;
  error?: string;
}

const initialState: RegionManagerState = {
  regionManagers: [],
  isFetching: false,
  isSaving: false,
};

export const regionManagerSlice = createSlice({
  name: 'regionManager',
  initialState,
  reducers: {
    retrieveRegionManagers: state => {
      state.isFetching = true;
      state.error = undefined;
    },
    retrieveRegionManagersSuccess: (state, action: PayloadAction<RegionManager[]>) => {
      state.regionManagers = action.payload;
      state.isFetching = false;
    },
    retrieveRegionManagersFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isFetching = false;
    },
    createRegionManager: (state, _action: PayloadAction<RegionManager>) => {
      state.isSaving = true;
      state.error = undefined;
    },
    removeRegionManager: (state, _action: PayloadAction<number>) => {
      state.isSaving = true;
      state.error = undefined;
    },
    saveRegionManagerSuccess: state => {
      state.isSaving = false;
    },
    saveRegionManagerFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isSaving = false;
    },
  },
});

export type RegionManagerViewModel = {
  regionManagers: RegionManager[];
  isFetching: boolean;
  isSaving: boolean;
  error?: string;
};

export const selectRegionManagerViewModel = createSelector(
  (state: RootState) => state,
  (state): RegionManagerViewModel => ({
    regionManagers: state.regionManager.regionManagers,
    isFetching: state.regionManager.isFetching,
    isSaving: state.regionManager.isSaving,
    error: state.regionManager.error,
  }),
);

export const {
  createRegionManager,
  removeRegionManager,
  retrieveRegionManagers,
  retrieveRegionManagersFailure,
  retrieveRegionManagersSuccess,
  saveRegionManagerFailure,
  saveRegionManagerSuccess,
} = regionManagerSlice.actions;

export default regionManagerSlice.reducer;
